import { render, staticRenderFns } from "./confirm-draft-actionbar.vue?vue&type=template&id=607b5904&"
import script from "./confirm-draft-actionbar.vue?vue&type=script&lang=ts&"
export * from "./confirm-draft-actionbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports